export const isFetching = state =>
  state.accounts.assignedDocumentRequests.fetching;
export const assignedDocumentRequests = state =>
  state.accounts.assignedDocumentRequests.assignedDocumentRequests;
